import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@mui/material/Alert";
import "../index.css";

/**
 * [ActionAlerts description]
 * @param {[string]} theme [The theme of the component - default: light]
 * @param {[node]} children [The content of the component.]
 * @param {[string]} styleVariant [Used to represent colored interface elements for a user - default: primary]
 * @param {[string]} variant [The variant to use - default: filled]
 * @param {[any]} ...props [Other valid props for MUI Alert]
 * @returns {[object]} [Returns the Alert component]
 */
const ActionAlerts = (props) => {
  const {
    theme = "light",
    children,
    styleVariant = "primary",
    variant = "filled",
    ...remaining
  } = props;

  const useStyles = makeStyles(() => ({
    typographyStyle: {
      fontFamily: "var(--fontFamily) !important",
      fontSize: "var(--font-size-S) !important",
      backgroundColor: `var(--${styleVariant}-alert-bgcolor-${theme}) !important`,
      color: `var(--${styleVariant}-alert-textcolor-${theme}) !important`,
    },
  }));
  const classes = useStyles();

  return (
    <Alert
      className={classes.typographyStyle}
      variant={variant}
      icon={false}
      {...remaining}
    >
      {children}
    </Alert>
  );
};

ActionAlerts.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.oneOf(["light", "dark"]),
  styleVariant: PropTypes.oneOf(["primary", "secondary"]),
  variant: PropTypes.oneOf(["filled"]),
};

export default ActionAlerts;
